import { View } from 'foundations-components/components/View';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MobilePanelBody = /*#__PURE__*/forwardRef(({
  children
}, ref) => {
  return /*#__PURE__*/_jsx(View, {
    flex: 1,
    minBlockSize: "auto",
    overflow: "auto",
    position: "relative",
    ref: ref,
    children: children
  });
});
export default MobilePanelBody;